package one.healthium.settings.domain

data class SettingsMenuModel(
    val title: String,
    val url: String,
)
